module.exports = __webpack_public_path__ + "static/media/ic-securite.5dc8ef66.svg";